module.exports = "/_next/static/images/sprite-icons-53893024f06cc39fa6dc7e6e50e942a1.svg";